import { GtmEvents } from '@/gtm/gtm-events';

export class CartMergeGtmEvents extends GtmEvents {
  constructor() {
    super('СобытияВКорзине');
  }

  showModal() {
    return this.gtmEvent({
      eventAction: 'Корзина_Слияние_Показ',
    });
  }

  onClickDelete() {
    return this.gtmEvent({
      eventAction: 'Корзина_Слияние_Удалить',
    });
  }

  onClickSave() {
    return this.gtmEvent({
      eventAction: 'Корзина_Слияние_Сохранить',
    });
  }

  onClickCross() {
    return this.gtmEvent({
      eventAction: 'Корзина_Слияние_Крестик',
    });
  }

  onClickOutside() {
    return this.gtmEvent({
      eventAction: 'Корзина_Слияние_КликВнеПоля',
    });
  }
}

export const cartMergeGtmEvents = new CartMergeGtmEvents();
